import React from 'react';
import { Field, change } from 'redux-form';
import styles from '../SalesTypeModal.css';

class SalesTypeFieldArray extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      salesTypeSearch: '',
      selectLabel: this._isAllSelected() ? 'Unselect All' : 'Select All',
    };
  }

  _handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  _handleInput = () => {
    this.setState({
      selectLabel: this._isAllSelected() ? 'Unselect All' : 'Select All',
    });
  };

  _isAllSelected = () => {
    const { fields } = this.props;
    let isAllSelected = true;
    fields.forEach((_, index) => {
      if (!fields.get(index).selected) {
        isAllSelected = false;
      }
    });
    return isAllSelected;
  };

  _selectUnselectAllSalesType = () => {
    if (this._isAllSelected()) {
      this._unselectAllSalesType();
    } else {
      this._selectAllSalesType();
    }
  };

  _selectAllSalesType = () => {
    const { fields, dispatch } = this.props;

    fields.forEach((member, index) => {
      if (
        fields
          .get(index)
          .name.toLowerCase()
          .indexOf(this.state.salesTypeSearch.toLowerCase()) > -1
      ) {
        dispatch(change('modal_sales_type', `${member}.selected`, true));
      }
    });

    this.setState({ selectLabel: 'Unselect All' });
  };

  _unselectAllSalesType = () => {
    const { fields, dispatch } = this.props;

    fields.forEach((member, index) => {
      if (
        fields
          .get(index)
          .name.toLowerCase()
          .indexOf(this.state.salesTypeSearch.toLowerCase()) > -1
      ) {
        dispatch(change('modal_sales_type', `${member}.selected`, false));
      }
    });

    this.setState({ selectLabel: 'Select All' });
  };

  render() {
    const { fields } = this.props;
    const salesTypeFilter = [];
    let countSelectedSalesType = 0;
    fields.forEach((_, index) => {
      fields.get(index).selected && countSelectedSalesType++;
    });

    fields.forEach((member, index) => {
      if (
        fields
          .get(index)
          .name.toLowerCase()
          .indexOf(this.state.salesTypeSearch.toLowerCase()) > -1
      ) {
        salesTypeFilter.push(
          <tr key={index}>
            <td className={styles.salesType}>{fields.get(index).name}</td>
            <td className={styles.selectedSalesType}>
              <Field
                name={`${member}.selected`}
                component={`input`}
                type={`checkbox`}
                onInput={this._handleInput}
              />
            </td>
          </tr>
        );
      }
    });

    return (
      <div className="row">
        <div className="col-sm-12">
          <div className="right-inner-addon">
            <i className="fa fa-search">&nbsp; </i>
            <input
              type="text"
              className="form-control"
              name={`salesTypeSearch`}
              onChange={this._handleChange}
              placeholder={`Search Sales Type`}
            />
          </div>
        </div>
        <div className="col-sm-12">
          <table className={styles['table-header']}>
            <thead>
              <tr>
                <th className={styles.salesType}>
                  {countSelectedSalesType} Sales Type selected
                </th>
                <th className={styles.selectedSalesType}>
                  <a onClick={this._selectUnselectAllSalesType}>
                    {this.state.selectLabel}
                  </a>
                </th>
              </tr>
            </thead>
          </table>
          <div
            className={`${
              styles['table-content-wrapper']
            } sales-type-modal-table-content-wrapper`}
          >
            <table className={styles['table-content']}>
              <tbody>{salesTypeFilter}</tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default SalesTypeFieldArray;
